import { render, staticRenderFns } from "./DistrictsLayer.vue?vue&type=template&id=12941b98"
import script from "./DistrictsLayer.vue?vue&type=script&lang=js"
export * from "./DistrictsLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports